<mat-toolbar class="ori-elevation-z4 header">
  <img src="./assets/img/logo_ORION2.png" alt="ORION2 logo" />
  @if (data.consult) {
    <div mat-dialog-close>
      <mat-icon class="icon" svgIcon="close"></mat-icon>
    </div>
  }
</mat-toolbar>

<mat-dialog-content [ngClass]="{ 'content-container-edit': data.consult }" class="content-container">
  <div class="content" [innerHtml]="content | async | safeHTML"></div>
</mat-dialog-content>

@if (!data.consult) {
  <mat-dialog-actions class="actions ori-elevation-z4">
    <form [formGroup]="agreement">
      <mat-radio-group formControlName="response">
        <mat-radio-button oPlayId pidValue="disclaimer-accept-btn" pidSelector="input[type='radio']" value="true"
          >{{ "disclaimer." + data.type + ".accept" | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </form>
    <button
      mat-raised-button
      mat-dialog-close
      cdkFocusInitial
      class="validate-button"
      color="primary"
      type="button"
      oPlayId
      pidValue="disclaimer-next-btn"
      [disabled]="!agreement.value.response">
      Next
    </button>
  </mat-dialog-actions>
}
